import * as React from "react";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import Layout from "../layout/default";
import Home from "../pages/home";
import DashboardAppPaoDiario from "../pages/dashboard/app-pao-diario";
import DashboardAppPaoDiarioMilitar from "../pages/dashboard/app-pao-diario-militar";
import DashboardAppPaoDiarioUniversitario from "../pages/dashboard/app-pao-diario-universitario";
import Audience from "../pages/dashboard/audience";
import WhatsappChannels from "../pages/tools/whatsapp-channels";
import Channels from "../pages/tools/channels";
import Finance from "../pages/tools/finance";
import Registers from "../pages/tools/registers";
import Donations from "../pages/tools/donations";
import Subscriptions from "../pages/tools/subscriptions";
import DashboardCampaigns from "../pages/tools/dashboardCampaigns";
import MotivationCodes from "../pages/tools/motivation-codes";
import MotivationCodeContentPage from "../pages/tools/motivation-codes/content";
import Events from "../pages/tools/events";
import EventForm from "../pages/tools/events/form";
import EventContent from "../pages/tools/events/content";
import EventRegistrations from "../pages/tools/events/registrations";
import EventAttendees from "../pages/tools/events/attendees";
import Pages from "../pages/cms/pages";
import FormPages from "../pages/cms/pages/form";
import AdminUsers from "../pages/admin/users";

const App = () => {
  let routes = useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/", element: <Home /> },
        {
          path: "dashboard/app-pao-diario",
          element: <DashboardAppPaoDiario />,
        },
        {
          path: "dashboard/app-pao-diario-militar",
          element: <DashboardAppPaoDiarioMilitar />,
        },
        {
          path: "dashboard/app-pao-diario-universitario",
          element: <DashboardAppPaoDiarioUniversitario />,
        },
        {
          path: "dashboard/audience",
          element: <Audience />,
        },
        {
          path: "tools/whatsapp-channels",
          element: <WhatsappChannels />,
        },
        {
          path: "tools/channels",
          element: <Channels />,
        },
        {
          path: "tools/finance",
          element: <Finance />,
        },
        {
          path: "tools/channels/:channelId/dashboard",
          element: <DashboardCampaigns />,
        },
        {
          path: "tools/channels/:channelId/subscriptions",
          element: <Subscriptions />,
        },
        {
          path: "tools/channels/:channelId/donations",
          element: <Donations />,
        },
        {
          path: "tools/registers",
          element: <Registers />,
        },
        {
          path: "tools/registers/:registerId/subscriptions",
          element: <Subscriptions />,
        },
        {
          path: "tools/registers/:registerId/donations",
          element: <Donations />,
        },
        {
          path: "tools/donations",
          element: <Donations />,
        },
        {
          path: "tools/subscriptions",
          element: <Subscriptions />,
        },
        {
          path: "tools/motivation-codes",
          element: <MotivationCodes />,
        },
        {
          path: "tools/motivation-codes/:motivationCode/content",
          element: <MotivationCodeContentPage />,
        },
        {
          path: "tools/events",
          element: <Events />,
        },
        {
          path: "tools/events/new",
          element: <EventForm />,
        },
        {
          path: "tools/events/:eventId/edit",
          element: <EventForm />,
        },
        {
          path: "tools/events/:eventId/content",
          element: <EventContent />,
        },
        {
          path: "tools/events/:eventId/registrations",
          element: <EventRegistrations />,
        },
        {
          path: "tools/events/:eventId/attendees",
          element: <EventAttendees />,
        },
        {
          path: "cms/pages",
          element: <Pages />,
        },
        {
          path: "cms/pages/:pageId",
          element: <FormPages />,
        },
        {
          path: "cms/pages/new",
          element: <FormPages />,
        },
        {
          path: "admin/users",
          element: <AdminUsers />,
        },
      ],
    },
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

export default AppWrapper;
